import Vue from 'vue';
import trace from "../trace.mjs";
import template from './postcode-search.html';
import apiService from "../api.mjs";
import { formatPostcode, isPostcode } from "../helpers/postcodes.mjs";
import {
    DialogBox,
    dialogDefaultConfiguration,
    dialogDefaultData,
    dialogDefaultMethods,
    emittableValues,
} from './dialog-box.mjs';

const tagName = 'dialog-postcodesearch';

const states = {
    NEEDS_POSTCODE : 'needs postcode',
    SEARCHING      : 'searching',
    NOT_FOUND      : 'not found',
    FOUND          : 'found',
    ERROR          : 'error'
};

export const postcodeSearchDefinition = {
    ...dialogDefaultConfiguration,
    template : template,
    data     : () => ({
        ...dialogDefaultData,
        states : states
    }),
    methods : {
        ...dialogDefaultMethods,
        onPostcodeEnterKey() {
            this.model.onSearchButtonClick();
        }
    }
};

Vue.component( tagName, postcodeSearchDefinition );

export class PostcodeSearchDialog extends DialogBox {

    constructor( postcode ) {
        super();
        this.postcode = postcode;
        this.error    = null;
        this.location = null;
        this.loaded   = false;
        this.state    = 0;

        if( this.postcode ) {
            this.requestPostcodeLocation( this.postcode );
        }

        this.updateState();
    }

    getComponentData() {
        return {
            state    : this.state,
            postcode : this.postcode,
            error    : this.error,
            loaded   : this.loaded,
            location : this.location,
        };
    }

    getComponentTag() {
        return tagName;
    }

    onDropOffClick( event ) {
        const form = this.component.$refs['dropOffOrderForm'];
        if( form ) {
            event.preventDefault();
            form.submit();
            return false;
        }
        return true;
    }

    onSearchButtonClick( event=null )
    {
        if( event )
            event.preventDefault();

        if( ! isPostcode(this.postcode) ) {
            this.error = 'Please enter a valid postcode';
            return;
        }

        this.error    = null;
        this.postcode = formatPostcode( this.postcode );
        this.requestPostcodeLocation( this.postcode );
        this.updateState();
    }

    onValueEmitted( value, ...extra ) {
        if( value === emittableValues.CANCEL )
            this.close();
        if( value === emittableValues.NO ) {
            this.postcode = null;
            this.loaded   = false;
            this.updateState();
        }
    }

    setDialogState( loaded, location ) {
        this.loaded   = loaded;
        this.location = location;
        this.updateState();
        return this;
    }

    resetState() {
        this.postcode = null;
        this.setDialogState( false, null );
    }

    requestPostcodeLocation( postcode ) {
        apiService.getLocationForPostcode( postcode )
            .then( location => {
                // if( mediaQueryState.isMobile() ) {
                //     return;
                // }
                this.setDialogState( true, location );
            })
            .catch( error => {
                // const errorDialog = new ErrorAlertDialog();
                // dialogBoxManager.pushDialog( errorDialog );
                console.warn( 'An error occurred!', error );
                this.state = states.ERROR;
            })
        ;
    }

    updateState() {
        this.state = this._determineState();
        trace.info( `Postcode search dialog: state updated to '${this.state}'` );
    }

    _determineState() {
        if( ! this.postcode )
            return states.NEEDS_POSTCODE;
        if( ! this.loaded )
            return states.SEARCHING;

        return this.location ? states.FOUND : states.NOT_FOUND
    }



}



